import React from 'react';
import { Link } from 'react-router-dom';
import { X, RefreshCw } from 'lucide-react';
import VehicleBrandLogo from './VehicleBrandLogo';
import { vehicleStore } from '../services/vehicleStore';
import { useT } from '../services/i18n';

const FUEL_LABELS = { essence: 'Essence', diesel: 'Diesel', hybride: 'Hybride', 'essence/électrique': 'Essence/électrique', 'diesel/électrique': 'Diesel/électrique', 'essence/gpl': 'Essence / gaz combustible liquéfié (GPL)', 'essence/éthanol': 'Essence/éthanol', 'essence/éthanol/gaz': 'Essence / éthanol / gaz', 'électrique': 'Électrique', gpl: 'GPL' };

const VehicleBanner = ({ vehicle, count, showAll, onToggleShowAll }) => {
  const { t } = useT();
  if (!vehicle) return null;
  return (
    <div data-testid="vehicle-banner" className="bg-gradient-to-r from-orange-50 to-orange-100 border border-orange-200 rounded-lg p-4 mb-6 flex flex-wrap items-center gap-4">
      <VehicleBrandLogo brand={vehicle.brand} model={vehicle.model} size={64} preferModel zoom testId="vehicle-banner-logo" />
      <div className="flex-1 min-w-[200px]">
        <p className="text-xs font-medium text-orange-700 uppercase tracking-wide">{t('cat.yourVehicle')}</p>
        <p className="font-semibold text-gray-900" data-testid="vehicle-banner-label">
          {vehicle.brand} {vehicle.model} <span className="text-gray-500 font-normal">({vehicle.year})</span>
        </p>
        <p className="text-sm text-gray-600">
          {vehicle.engine?.name} · {vehicle.engine?.power}ch · {FUEL_LABELS[vehicle.engine?.fuel] || vehicle.engine?.fuel}
        </p>
      </div>
      {typeof count === 'number' && (
        <span data-testid="vehicle-banner-count" className="text-sm bg-white text-gray-700 px-3 py-1 rounded-full border border-orange-200">
          {count} pièce{count > 1 ? 's' : ''} compatible{count > 1 ? 's' : ''}
        </span>
      )}
      <div className="flex items-center gap-2">
        {onToggleShowAll && (
          <button
            data-testid="vehicle-banner-toggle"
            onClick={onToggleShowAll}
            className="text-sm text-blue-600 hover:underline"
          >
            {showAll ? t('cat.onlyCompatible') : t('cat.allParts')}
          </button>
        )}
        <Link to="/" data-testid="vehicle-banner-change" className="inline-flex items-center gap-1 text-sm text-gray-700 hover:text-orange-600">
          <RefreshCw size={14} /> {t('cat.change')}
        </Link>
        <button
          data-testid="vehicle-banner-clear"
          onClick={() => vehicleStore.clear()}
          className="p-1.5 rounded-full hover:bg-white/70 text-gray-500 hover:text-red-500"
          title={t('header.removeVehicle')}
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default VehicleBanner;
